import { render, staticRenderFns } from "./TransactionsViewTab.vue?vue&type=template&id=b9666f66&scoped=true&"
import script from "./TransactionsViewTab.vue?vue&type=script&lang=js&"
export * from "./TransactionsViewTab.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsViewTab.vue?vue&type=style&index=0&id=b9666f66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9666f66",
  null
  
)

export default component.exports